import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

const SocialLinks = () => {
  return (
    <div className="flex gap-4 items-center">
      <a
        href="https://www.facebook.com/profile.php?id=61557808207070"
        target="_blank"
        rel="noopener noreferrer"
        className="text-secondary hover:text-primary transition-colors"
      >
        <Facebook size={24} />
      </a>
      <a
        href="https://www.instagram.com/evolutionsmedspa/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-secondary hover:text-primary transition-colors"
      >
        <Instagram size={24} />
      </a>
      <a
        href="https://x.com/Evolvedyou_"
        target="_blank"
        rel="noopener noreferrer"
        className="text-secondary hover:text-primary transition-colors"
      >
        <Twitter size={24} />
      </a>
      <a
        href="https://www.linkedin.com/in/william-gray-dmd-md-mba-facs-6652bba/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-secondary hover:text-primary transition-colors"
      >
        <Linkedin size={24} />
      </a>
      <a
        href="https://bsky.app/profile/idaltu.bsky.social"
        target="_blank"
        rel="noopener noreferrer"
        className="text-secondary hover:text-primary transition-colors"
      >
        <Twitter size={24} className="transform rotate-45" />
      </a>
    </div>
  );
};

export default SocialLinks;